import type { SVGProps } from 'react'

const MessageRounded = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M20.5 2H4.5C3.4 2 2.51 2.9 2.51 4L2.5 22L6.5 18H20.5C21.6 18 22.5 17.1 22.5 16V4C22.5 2.9 21.6 2 20.5 2ZM17.5 14H7.5C6.95 14 6.5 13.55 6.5 13C6.5 12.45 6.95 12 7.5 12H17.5C18.05 12 18.5 12.45 18.5 13C18.5 13.55 18.05 14 17.5 14ZM17.5 11H7.5C6.95 11 6.5 10.55 6.5 10C6.5 9.45 6.95 9 7.5 9H17.5C18.05 9 18.5 9.45 18.5 10C18.5 10.55 18.05 11 17.5 11ZM17.5 8H7.5C6.95 8 6.5 7.55 6.5 7C6.5 6.45 6.95 6 7.5 6H17.5C18.05 6 18.5 6.45 18.5 7C18.5 7.55 18.05 8 17.5 8Z'
        fill='black'
        fillOpacity='0.54'
      />
    </svg>
  )
}

export default MessageRounded
